<tyt-paywall [noun]="noun"></tyt-paywall>